var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._l((_vm.studentGoals),function(goal,i){return _c('div',{key:i},[_c('div',{staticClass:"goal-name"},[_vm._v(_vm._s(goal.cmsGoal.name))])])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }